import RoleContainer from "../../../Component/Application/rolemanagement/role-container";

const RolePage = () => {
    return (
        <div className="page-body">
            <RoleContainer />
        </div>
    );
};

export default RolePage;